import { FC } from 'react';
import
{
    SubmissionNetwork
} from "@ews/react-data";

import s from '../SystemDocumentation.module.scss';
import { useL10n } from '@ews/react-localization-context';

const TableSubmissionNetwork: FC<{ data: Record<number, SubmissionNetwork>; }> = ({
    data
}) =>
{

    const { translate: t } = useL10n();
    if (!data) return <>{t("[REACT_NO_DATA]")}</>;
    /* console.log("data", data); */
    return <table id='system-documentation-submission-network' data-name='Einreichung Vernetzung' className={s.table}>
        <thead>
            <tr>
                <td style={{ width: "40px" }}></td>
                <td style={{ width: "250px" }}></td>
                <td style={{ width: "40px" }}></td>
                <td style={{ width: "250px" }}></td>
                <td style={{ width: "290px" }}></td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={4}>{t("[REACT_FIRE_ALARM_SYSTEM]")}</td>
                <td className={`${s.b} ${s.title}`} colSpan={1}>{t("[REACT_TRVB_123_S]")}</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={4}>Vernetzte Brandmeldeanlagen Zusätzliche Einreichunterlagen</td>
                <td className={`${s.bR} ${s.title}`} colSpan={1}>{t("[REACT_ANHANG_1]")}</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bR} ${s.title}`} colSpan={1}>{t("[REACT_VERNETZUNG]")}</td>
            </tr>

            {Object.entries(data).map(([key, value]) => (
                <>
                    <tr>
                        <td colSpan={1} rowSpan={20} className={`${s.b} ${s.aT} ${s.tL}`}>Teilnehmer {value.number}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tL}`}>{value.location}</td>
                        <td colSpan={1} rowSpan={20} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{t("TD_TYPE")}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.type}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>Übertragungsgruppen gesamt:</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.totalTransmissionGroups}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>Bediengruppen gesamt:</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.totalControlGroups}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>mit automatischen Meldern:</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.automaticFireDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>mit nichtautomatischen Meldern:</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.nonAutomaticFireDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}></td>
                    </tr>
                    <tr>
                        <td colSpan={3} className={`${s.b} ${s.aT} ${s.tC}`}>{'-'}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} rowSpan={13} className={`${s.b} ${s.aT} ${s.tL}`}>Anzahl Melder:</td>
                        <td colSpan={2} className={`${s.b} ${s.aT} ${s.tC}`}>{"-"}</td>
                    </tr>

                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>Wärmemelder Max.</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>Wärmemelder Diff.</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{t("[SID_LEL_TYPE_OPT]")}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{t("[SID_LEL_TYPE_IONIS]")}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{t("[REACT_MULTIKRITERIENMELDER]")}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{t("[SID_GRP_KIND_MCP]")}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>{value.linearSmokeDetectors}</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{t("TD_LINEARER_MELDER")}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>-</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>-</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>-</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>-</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>-</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>-</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>-</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>-</td>
                    </tr>
                    <tr>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tC}`}>-</td>
                        <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>-</td>
                    </tr>
                </>

            ))}




        </tbody>
    </table>;
};

export default TableSubmissionNetwork;
